import styled from 'styled-components';
import { Accordion as BaseAccordion, body, bodySemiBold } from '@ubeya/shared-web/components';

const Accordion = styled(BaseAccordion)`
  padding: 0px 8px;

  > .group {
    ${body};
    border: none;
    background: inherit;
    padding: 4px 24px;
    position: relative;

    .circle-icon {
      margin-right: -4px;
    }
  }

  > .group::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.grey2};
  }

  > .content {
    box-shadow: none;
    padding: 8px 24px 16px 32px;
    border: none;
    flex-direction: column;
    gap: 8px;
  }

  &:last-child::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 8px;
    right: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.grey2};
  }

  &:last-child {
    position: relative;
  }

  span {
    ${bodySemiBold}
  }
`;

export default Accordion;
